import { render } from "./default.vue?vue&type=template&id=453413bc&scoped=true"
import script from "./default.vue?vue&type=script&lang=ts"
export * from "./default.vue?vue&type=script&lang=ts"

import "./default.vue?vue&type=style&index=0&id=453413bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-453413bc"

export default script